import { AuthPage } from "@refinedev/antd";

export const ResetPassword = () => {
  return <AuthPage type="updatePassword" />;
};
